<template>
  <div class="menu-list">
    <div class="menu-item" @click="menuClickFn('download')" v-show="hasDownload">
      <span>下载</span>
      <i class="iconfont icon-icon-gongnenglei"></i>
    </div>
    <div class="menu-item" @click="menuClickFn('share')">
      <span>分享</span>
      <i class="iconfont icon-a-icon-gongnenglei1"></i>
    </div>
    <div class="menu-item" @click="menuClickFn('delete')">
      <span>删除</span>
      <i class="iconfont icon-a-icon-gongnenglei2"></i>
    </div>
    <div class="menu-item" @click="menuClickFn('info')">
      <span>属性</span>
      <i class="iconfont icon-a-Union6"></i>
    </div>
  </div>
</template>
<script>
import ajax from '@/utils/ajax'
import { DOCUMENT_DELETE, BOOK_PRESIGN_DOWNLOAD } from '@/config/api'
import { menuMixin, CommonMixin } from './commonMixin'
import config from '@/config'
import { toast } from '@/utils/common'
export default {
  name: 'MenuList',
  mixins: [menuMixin, CommonMixin],
  props: {
    cardData: {
      type: Object,
      default () {
        return {}
      }
    },
    permissionsData: {
      type: Object,
      default: () => ({})
    }
  },
  components: {

  },
  data () {
    return {
      sortType: 'date'
    }
  },
  computed: {
    hasDownload () {
      let has_permission = false
      let permissionsData = this.cardData.library_user_permission || this.permissionsData
      permissionsData.permissions && permissionsData.permissions.forEach(item => {
        if (item.id === 'download' && item.value) {
          has_permission = true
        }
      })
      return permissionsData.is_admin || has_permission
    }
  },
  mounted () {

  },
  methods: {
    menuClickFn (type) {
      let id = this.cardData.id || this.cardData.item_id
      if (type === 'delete') {
        ajax({
          url: DOCUMENT_DELETE,
          baseUrl: config.doclib_application_url,
          noPrefix: true,
          data: {
            book_ids: id ? [id] : [],
            document_id: this.cardData.document_id ? [this.cardData.document_id] : [],
            library_id: this.cardData.library_id
          }
        }).then(res => {
          if (res.success) {
            toast('删除成功')
          } else {
            toast(res.message)
          }

          this.$emit('menu-click', 'delete', this.cardData)
        })
      } else if (type === 'download') {
        this.appFn({
          action: 'download',
          data: this.cardData
        }, () => {
          ajax({
            url: BOOK_PRESIGN_DOWNLOAD,
            baseUrl: config.doclib_application_url,
            noPrefix: true,
            data: {
              book_id: id,
              library_id: this.cardData.library_id
            }
          }).then(res => {
            if (res.success) {
              this.downloadFile(res.data, this.cardData.name)
            } else {
              toast(res.message)
            }

            this.$emit('menu-click', 'download', this.cardData)
          })
        }, () => {
          this.$emit('menu-click', 'download', this.cardData)
        })
      } else if (type === 'share') {
        let shareLink = `${window.location.origin}/h5/doclib/files/${this.cardData.library_id}/preview?library_id=${this.cardData.library_id}&book_id=${this.cardData.id || this.cardData.item_id}${this.cardData.file_version ? '&file_version=' + this.cardData.file_version : ''}`
        this.appFn({
          action: 'share',
          data: shareLink
        }, () => {
          this.copyLinkToClipboard(shareLink)
        })
        toast('链接复制成功')
        this.$emit('menu-click', 'share', this.cardData)
      } else {
        this.$emit('menu-click', type, this.cardData)
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
.menu-list {
  width: 100%;
  border-radius: 16px 16px 8px 8px;
  background: #F7F9FA;

  & .menu-item {
    display: flex;
    height: 50px;
    padding: 0px 24px;
    justify-content: space-between;
    align-items: center;

    & span {
      color: #1B2532;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
    }

    & i {
      font-size: 24px;
      color: #1B2532;
    }
  }
}
</style>
